import { styled } from "styled-components";

export const CompanyLogoContainer = styled.div`
  /* display: flex;
  justify-content: center; */
`;
